import { render, staticRenderFns } from "./W1V1.vue?vue&type=template&id=54daa364&scoped=true&"
import script from "./W1V1.vue?vue&type=script&lang=js&"
export * from "./W1V1.vue?vue&type=script&lang=js&"
import style0 from "./W1V1.vue?vue&type=style&index=0&id=54daa364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54daa364",
  null
  
)

export default component.exports